import React from 'react';
import { useResponsiveLayout } from '../../context/ResponsiveLayoutContext';

function SidebarBackdrop() {
  const { isDrawerMode, isNavOpen, isAnalyticsNavOpen, closeAllNav } = useResponsiveLayout();

  if (!isDrawerMode || (!isNavOpen && !isAnalyticsNavOpen)) {
    return null;
  }

  return (
    <button
      type="button"
      className="sidebar-backdrop"
      onClick={closeAllNav}
      aria-label="Close navigation"
    />
  );
}

export default SidebarBackdrop;
